import { ShoppingCartIcon } from 'packages/eid-icons'
import { Header } from 'packages/eid-ui'
import { Badge, Box, Divider, styled, useTheme } from '@mui/material'
import { useIsSmallScreen, useQuery } from 'packages/core'
import { useAllCarts, useCart } from 'hooks'
import { Cart } from 'components'
import CartDropdown from '../CartDropdown'
import { Skeleton } from '@mui/material'
import { useHistory } from 'react-router'
import { useRef } from 'react'

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: theme?.palette?.quaternary?.main,
        color: theme?.palette?.common?.white,
        height: '16px',
        minWidth: '12px',
        fontSize: '10px',
    },
}))

const GroupedButtonContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme?.palette?.primary?.main,
    height: '34px',

    border: '1px solid transparent',
    borderRadius: '5px',

    '& >div': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '&:hover': {
            cursor: 'pointer',
        },
    },

    '& >div:first-child': {
        borderRight: '1px solid  #b4b4b4',
    },
}))

const ShoppingCartMenuIcon = ({
    showDivider = true,
    showDrawer = true,
    hideOnOpenDrawer = true,
}) => {
    const history = useHistory()
    const query = useQuery()
    const cartOpen = query.get('cart') === 'visible'
    const isSmallScreen = useIsSmallScreen()
    const theme = useTheme()
    const anchorRef = useRef(null)

    const { data: cart } = useCart()
    const { hasMultipleCarts } = useAllCarts()

    return (
        <>
            {showDivider && (
                <Header.Item
                    style={{ minWidth: isSmallScreen ? '30px' : '40px' }}
                >
                    <Divider
                        orientation="vertical"
                        variant="fullWidth"
                        style={{
                            backgroundColor: '#e8e8e8',
                            height: 26,
                        }}
                    />
                </Header.Item>
            )}

            <Header.Item
                style={{
                    marginRight: isSmallScreen ? '8px' : '35px',
                    visibility:
                        cartOpen && hideOnOpenDrawer ? 'hidden' : 'visible',
                }}
            >
                {!cart ? (
                    <Skeleton width="80px" height="34px" />
                ) : (
                    <GroupedButtonContainer backgroundColor="#0057A0">
                        <Box
                            backgroundColor="#0057A0"
                            component="button"
                            sx={{
                                border: 'none',
                                borderRight: '1px solid white',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                query.set('cart', 'visible')
                                history.push(
                                    `${
                                        history.location.pathname
                                    }?${query.toString()}`,
                                )
                            }}
                        >
                            <StyledBadge badgeContent={cart.cartItems.length}>
                                <ShoppingCartIcon
                                    color={theme?.palette?.primary?.main}
                                    width="27px"
                                    height="27px"
                                />
                            </StyledBadge>
                        </Box>

                        <CartDropdown />
                        {hasMultipleCarts && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '-4px',
                                    right: 0,
                                    height: '8px',
                                    width: '8px',
                                    borderRadius: '50%',
                                    backgroundColor:
                                        theme?.palette?.quaternary?.main,
                                    zIndex: 3,
                                }}
                            />
                        )}
                    </GroupedButtonContainer>
                )}
            </Header.Item>
            {showDrawer && (
                <Cart
                    open={cartOpen}
                    ref={anchorRef}
                    toggleDrawer={() => {
                        query.delete('cart')
                        history.push(
                            `${history.location.pathname}?${query.toString()}`,
                        )
                    }}
                />
            )}
        </>
    )
}

export default ShoppingCartMenuIcon
